// Dependencies
import React from 'react';

// Utils
import { Stack, Columns, Column, Box } from '@nerdwallet/currency';

import {
  PurchasePriceInputWithAnalytics,
  LocationInputWithAnalytics,
  DownPaymentInputWithAnalytics,
  DownPaymentPercentInputWithAnalytics,
  AnnualInterestRateInputWithAnalytics,
  LoanTermInputWithAnalytics,
  MonthlyRentInputWithAnalytics,
} from './inputs';
import { INPUT_CONTENT } from './shared/content';

import styles from './control-panel.module.less';

const FirstPanel = (): JSX.Element => {
  return (
    <Stack>
      <LocationInputWithAnalytics
        label={INPUT_CONTENT.LOCATION.label}
        className={styles.locationInput}
        fullWidth
      />
      <PurchasePriceInputWithAnalytics
        label={INPUT_CONTENT.PURCHASE_PRICE.label}
        tooltip={INPUT_CONTENT.PURCHASE_PRICE.tooltip}
        fullWidth
      />
      <Box>
        <Columns alignY="top">
          <Column width="8">
            <DownPaymentInputWithAnalytics
              label={INPUT_CONTENT.DOWN_PAYMENT.label}
              tooltip={INPUT_CONTENT.DOWN_PAYMENT.tooltip}
              fullWidth
            />
          </Column>
          <Column width="4">
            <DownPaymentPercentInputWithAnalytics
              className={styles.marginTop}
              fullWidth
            />
          </Column>
        </Columns>
      </Box>
      <AnnualInterestRateInputWithAnalytics
        label={INPUT_CONTENT.ANNUAL_INTEREST_RATE.label}
        tooltip={INPUT_CONTENT.ANNUAL_INTEREST_RATE.tooltip}
        className={styles.inputPercentWidth}
        fullWidth
      />
      <LoanTermInputWithAnalytics
        label={INPUT_CONTENT.LOAN_TERM.label}
        tooltip={INPUT_CONTENT.LOAN_TERM.tooltip}
        fullWidth
      />
      <MonthlyRentInputWithAnalytics
        label={INPUT_CONTENT.MONTHLY_RENT.label}
        fullWidth
      />
    </Stack>
  );
};

export default FirstPanel;
